<script>
import FMD from "@/views/product/components/product-card/fmd/FMD.vue";

export default {
    components: {FMD},
    props: {
        productId: {
            required: true
        },
        section: {
            required: true
        }
    }
}
</script>

<template>
    <FMD
        :declarations="section.declarations"
        :product-id="productId"
        :read-only="true"
    />
</template>
